<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormColor" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objColor.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="Color">Color</label>
                            <div class="w-100">
                                <input type="color" v-model="objColor.Color" class="form-control-color p-2 w-75" id="Color" placeholder="Ingresar Color" />
                            </div>
							<CValidation v-if="this.errorvalidacion.Color" :Mensaje="'*'+errorvalidacion.Color[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
                        <label class="form-label" for="">Para</label>

						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
                                    <input type="checkbox" v-model="objColor.EnPedido" class="form-check-input" id="EnPedido" />
                                </div>
                                <span>Pedido</span>
                            </div>
							<CValidation v-if="this.errorvalidacion.EnPedido" :Mensaje="'*'+errorvalidacion.EnPedido[0]"/>
						</div>
					
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
                                    <!-- <input type="checkbox" v-model="objColor.EnPedido" class="form-check-input" id="EnPedido" /> -->
                                    <input type="checkbox" v-model="objColor.EnLenteC" class="form-check-input" id="EnPedido" />
                                </div>
                                <span>Lente de contacto</span>
                            </div>
							<!-- <label class="form-label" for="EnLenteC">Lente de contacto</label>
							<input type="text" v-model="objColor.EnLenteC" class="form-control" id="EnLenteC" placeholder="Ingresar EnLenteC" /> -->
							<CValidation v-if="this.errorvalidacion.EnLenteC" :Mensaje="'*'+errorvalidacion.EnLenteC[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormColor',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objColor: {
				IdColor: 0,
				Nombre: '',
				Color: '#000000',
				EnPedido: false,
				EnLenteC: false,
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
            let objColorCopy = {...this.objColor};
            objColorCopy.EnLenteC = this.objColor.EnLenteC ? 'SI':'NO';
            objColorCopy.EnPedido = this.objColor.EnPedido ? 'SI':'NO';

			if(this.objColor.IdColor == 0) {
				await this.$http.post(
					'colores',objColorCopy
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'colores/'+this.objColor.IdColor,
					objColorCopy
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "colores/"+this.objColor.IdColor
            ).then((res) => {
                this.objColor = res.data.data;
                this.objColor.EnLenteC = res.data.data.EnLenteC == 'SI';
                this.objColor.EnPedido = res.data.data.EnPedido == 'SI';
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objColor = {
				IdColor: 0,
				Nombre: '',
				Color: '#000000',
                EnPedido: false,
				EnLenteC: false,
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objColor.IdColor = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
